module.exports = __webpack_public_path__ + "static/media/warehoure_filled.230116eb.svg";